import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createStandaloneContract } from "api/contracts";

import { queryKeys } from "./queryKeys";

export const useCreateLeaseContract = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createStandaloneContract,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.contracts.lists() });
    },
  });
};
